function escapeHtml(value: string): string {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");
}

function stylesheetText(): string {
  const chunks: string[] = [];
  for (const sheet of Array.from(document.styleSheets)) {
    try {
      chunks.push(Array.from(sheet.cssRules, (rule) => rule.cssText).join("\n"));
    } catch {
      if (sheet.href) {
        chunks.push(`@import url("${sheet.href}");`);
      }
    }
  }
  return chunks.join("\n");
}

export function printDocumentHtml(html: string, title: string): void {
  if (!html.trim()) return;
  const previous = document.getElementById("document-print-frame");
  previous?.remove();
  const frame = document.createElement("iframe");
  frame.id = "document-print-frame";
  frame.className = "document-print-frame";
  frame.setAttribute("aria-hidden", "true");
  document.body.appendChild(frame);
  const doc = frame.contentDocument;
  if (!doc) {
    frame.remove();
    return;
  }
  const safeTitle = escapeHtml(title || "Document");
  doc.open();
  doc.write(`<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8" />
<title>${safeTitle}</title>
<style>
${stylesheetText()}
@page { margin: 12mm; }
html, body {
  background: var(--color-panel);
  margin: 0;
  padding: 0;
}
.crm-document-sheet {
  box-shadow: none;
  border: none;
  max-width: none;
  margin: 0;
  padding: 0;
}
</style>
</head>
<body>
<div class="crm-document-sheet">${html}</div>
</body>
</html>`);
  doc.close();
  const win = frame.contentWindow;
  if (!win) {
    frame.remove();
    return;
  }
  const cleanup = () => {
    frame.remove();
  };
  win.addEventListener("afterprint", cleanup);
  window.setTimeout(() => {
    win.focus();
    win.print();
  }, 50);
}
